<script lang="js">
import dayjs from '@util/dayjs';

export default {
  data() {
    return {
    }
  },

  methods: {
    makeNumberSigned(number, customZeroPrefix = undefined, reverse = false) {
      if (isNaN(number)) {
        return '-';
      }
      if (number == 0) {
        const zeroPrefix = customZeroPrefix === undefined ? '+/-' : customZeroPrefix;
        return zeroPrefix + number;
      } else {
        let numberPrefix = number > 0 ? '+' : '';
        if (number > 0 && reverse == true) {
          numberPrefix = '-';
        }
        return numberPrefix + number;
      }
    },

    formatTimestamp(timestamp) {
      if (timestamp) {
        return dayjs(timestamp, 'YYYY-MM-DD').isValid() ? `${dayjs(timestamp).format('DD.MM.YYYY')} um ${dayjs(timestamp).format('HH:mm')} Uhr` : 'invalid';
      }
      return timestamp;
    },

    formatDate(date, today = false) {
      if (date) {
        if (dayjs(date, 'YYYY-MM-DD').isValid() == false) {
          return 'invalid';
        }

        if (today && dayjs(this.dayData.date).isSame(dayjs(), 'day')) {
          return 'Heute';
        } else {
          return dayjs(date).format('DD.MM.YYYY');
        }
      }
      return date;
    },

    getWeekdayName(day) {
      if (day.isPublicHoliday) {
        return 'Feiertag';
      } else {
        return dayjs(day.date, 'YYYY-MM-DD').format('dddd');
      }
    },

    projectDisplayName(item) {
      return item.shortName != null && item.shortName != '' ? item.shortName : item.name;
    }
  },
};
</script>